namespace SolovisGateway.Admin.Organizations {

    export interface OrgConnectionSetupPendingDialogOptions extends SupportContactOptions {
        connectionName: string;
        onClose?: () => void;
    }

    export class OrgConnectionSetupPendingDialog {

        private _options: OrgConnectionSetupPendingDialogOptions;

        constructor(options: OrgConnectionSetupPendingDialogOptions) {
            this._options = options;
        }

        public show() {
            var self = this;
            var dialog = null;

            var body = $("<div>").css({ "padding": "0 10px" });

            var warningBanner = $("<div>").css({
                "background-color": "#fcf8e3",
                "border": "1px solid #faebcc",
                "color": "#8a6d3b",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px"
            });
            warningBanner.text("The connection was created, but the setup link could not be generated.");
            body.append(warningBanner);

            var connectionNameParagraph = $("<p>");
            connectionNameParagraph.append("Connection ");
            connectionNameParagraph.append($("<strong>").text(this._options.connectionName));
            connectionNameParagraph.append(" is reserved.");
            body.append(connectionNameParagraph);

            var nextStepsParagraph = $("<p>");
            nextStepsParagraph.append("To get the setup link, go to Organization > Manage Connections > ");
            nextStepsParagraph.append($("<strong>").text("Configure"));
            nextStepsParagraph.append(" on this connection, then click ");
            nextStepsParagraph.append($("<strong>").text("Configure"));
            nextStepsParagraph.append(" again.");
            body.append(nextStepsParagraph);

            var supportParagraph = $("<p>");
            SsoConnectionStatusUi.appendSupportContactLine(supportParagraph, this._options, "If the problem continues, ", ".");
            body.append(supportParagraph);

            dialog = new (Solovis as any).UI.Dialog({
                container: body,
                title: "Setup link not generated",
                modal: true,
                autoOpen: true,
                center: true,
                destroyOnClose: true,
                actions: ["Close"],
                width: 500,
                close: function () {
                    if (self._options.onClose) {
                        self._options.onClose();
                    }
                },
                buttons: [
                    {
                        label: "Close",
                        click: function () {
                            dialog.close();
                        }
                    }
                ]
            });
        }
    }

}
